/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { OAuthClientsPage } from '@/pages/OAuthClients/OAuthClientsPage';

export function OAuthClientRoute() {
  return <OAuthClientsPage />;
}
